<template>
  <div class="loginPage">
    <header class="login__nav">
      <div class="navContainer">
        <a href="javascript:void(0);">
          <img src="@/assets/images/header_logo.png" alt="Logo" />
        </a>
      </div>
    </header>
    <div class="login__content">
      <div class="login__wrapper">
        <form @submit.prevent="createLogin">
          <div class="login__fields">
            <h2 class="login__fields__header primaryHeader mb-4">Log in</h2>
            <div class="form-group">
              <label for="email" class="login__label">Email</label>
              <input
                type="email"
                id="email"
                class="login__input"
                placeholder="Enter your email"
                autocomplete="off"
                v-model="form.email"
                @keypress="checkSubmission"
              />
            </div>
            <div class="form-group mb-2">
              <label for="password" class="login__label">Password</label>
              <input
                type="password"
                id="password"
                class="login__input"
                autocomplete="off"
                placeholder="Enter your password"
                v-model="form.password"
                @keypress="checkSubmission"
              />
            </div>
            <!-- <div class="login__forget">
              <p class="txt--xs text-danger">{{feedback}}</p>
              <router-link to="/forgot-password" class="ml-auto">Forgot password?</router-link>
            </div> -->
          </div>
          <div class="login__submit mt-4">
            <ButtonWithSpinner
              class="button button--md button__loader button--primary login__button"
              :loading="button.loading"
              :success="button.success"
              :disabled="form.email == '' || form.password == '' || button.disabled"
              @click="createLogin"
            >Submit</ButtonWithSpinner>
            <p class="txt--xs">
              Don’t have an account yet?
              <a
                href="mailto:hello@piedparker.com?subject=Hello!"
                class="txt--primary txt--semi-bold"
              >Get in touch</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonWithSpinner from "@/components/Button";
export default {
  name: "Login",
  components: { ButtonWithSpinner },
  data() {
    return {
      form: {
        email: "",
        password: "",
        device_type: 1,
        commercial: 1,
        device_token:'',
        udid:'',
      },
      button: {
        loading: false,
        success: false,
        disabled: false,
      },
      errors: {},
      feedback: "",
    };
  },
  created() {
    if (localStorage.getItem("commercial_token_new") != null) {
      if (
        this.$route.name != "ForgotPassword" ||
        this.$route.name != "VerifyEmail" ||
        this.$route.name != "Payment"
      ) {
        this.$router.push('/welcome')
        /* console.log('logged in')
        this.$router.push({
          name: "Welcome",
        }); */
      }
    }
  },
  methods: {
    checkLogin() {
      if (this.form.password == "" && this.form.email == "") {
        this.feedback = "Fill all the required fields ";
      } else if (this.email == "") {
        this.feedback = "Please enter your email";
      } else if (this.password == "") {
        this.feedback = "Please enter your password";
      }
    },
    checkSubmission(e) {
      if (e.keyCode === 13) {
        this.createLogin();
      }
    },
    createLogin() {
      //do login
      this.button.disabled = true;
      this.button.loading = true;
      this.form.device_token = localStorage.getItem("device_token") ;

      if(this.$route.name == 'OperatorLogin' && this.$route.params.uuid!='') {
        this.form.invitation_uuid = this.$route.params.uuid;
      }

      this.axios
        .post(window.hostname + "api/commercial/login", this.form)
        .then((res) => {
          console.log(res);
          if(res.data.status) {
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = true;
            localStorage.setItem("commercial_token_new", res.data.access_token);
            localStorage.setItem("loader",res.data.user.loader);
            //store the operators access list
            localStorage.setItem("role", res.data.user.role);
            localStorage.setItem("user_id", res.data.user.id);
            localStorage.setItem(
              "offstreet_integration_enabled",
              [true, 1, "1", "true"].includes(res.data.user.offstreet_integration_enabled)
                ? "true"
                : "false"
            );
            if (res.data.user.role == 'operator') {
              localStorage.setItem("commercial_access_list", JSON.stringify(res.data.user.access));
            }
          
            // let user_data = res.data.user ;
            //======= Initialize Support Section =========//
            // this.initSupport(user_data);
            // console.log(this.$route.query);
            if(this.$route.query.export_id && this.$route.query.export_id !='') {
              this.$router.push({
                name: "ExportReports",
                'params': {
                  'id': this.$route.query.export_id
                }
              });
              return;
            }

            this.$router.push({name : 'Welcome'});
          }
          else {
            this.$toasted.show(res.data.message,{
              icon: 'times-circle',
              className: 'error-class'
            });
            this.form.password = '';
          }
        })
        .catch((error) => {
          this.button.disabled = false;
          this.button.loading = false;
          this.button.success = false;
          this.errors = error.response ? error.response.data : null;
          this.form.password = '';
          this.$toasted.show(this.errors.message, {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
  },
};
</script>

<style></style>
